import api from 'app/base/axios';
import {
	UPLOAD_PATH,
	PERMANENT_PATH,
	TEMPORARY_PATH,
	STATIC_DATA,
	RESIZED_IMAGE_ENDPOINT,
	TicketCategories,
	FaqCategories
} from './consts';
import { useState } from 'react';
export const URL = process.env.REACT_APP_DOMAIN;
export function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export function saveCookie(name, value, days) {
	var expires = '';
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

export function getCookie(name) {
	var nameEQ = name + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

export function removeCookie(name) {
	document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const loadObject = key => getCookie(key) && JSON.parse(getCookie(key));

export const saveObject = (key, object) => saveCookie(key, JSON.stringify(object));

export const removeObject = key => removeCookie(key);

export const onlyPersianLetter = value => {
	var reg = /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF ]+$/;
	return reg.test(value);
};

export const onlyNumber = number => {
	var reg = /\d/;
	return reg.test(number);
};

export const copyToClipboard = text => {
	const elem = document.createElement('textarea');
	elem.value = text;
	document.body.appendChild(elem);
	elem.select();
	document.execCommand('copy');
	document.body.removeChild(elem);
};

export const resizedUrl = (file, width, height) =>
	`${process.env.REACT_APP_BASE_URL}/file/${file.id}/resized?width=${width}&height=${height}`;

export const resizedUrlFromFileId = (fileId, width, height) =>
	`${process.env.REACT_APP_BASE_URL}/file/${fileId}/resized?width=${width}&height=${height}`;

export const urlFromFileId = (fileId) =>
	`${process.env.REACT_APP_BASE_URL}/file/download/${fileId}`;

export const urlFromFileNameId = (fileId, extension) =>
	`${process.env.REACT_APP_BASE_URL}/file/name/${fileId}.${extension}`;

export const urlFromCmsImageUrl = (url) =>
	`${process.env.REACT_APP_CMS_BASE_URL}${url}`;

export const downloadByFileIdAndName = (fileId, name) => {
	const href = urlFromFileId(fileId);
	const link = document.createElement('a');
	link.href = href;
	link.download = name;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}
export const downloadByUrlAndName = (url, name) => {
	const href = url;
	const link = document.createElement('a');
	link.href = href;
	link.download = name;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}


export const textContentFromFileId = async (fileId) => (await api.get(`file/${fileId}`)).data


export const fileUrl = (file, isUsed = null) => {
	if (file == null) return ''
	if (isUsed === null) isUsed = true;
	if (file.isPermanent) return `${URL}/${PERMANENT_PATH}/${file.relativePath || file.id}/${file.fileName}`;
	else return `${URL}/${isUsed ? UPLOAD_PATH : TEMPORARY_PATH}/${file.guid}/${file.fileName}`;
};
export const getImageSize = url =>
	new Promise((resolve, reject) => {
		let img = new Image();
		img.onload = function () {
			resolve({ width: this.width, height: this.height });
		};
		img.onerror = function () {
			reject('Error!');
		};
		img.src = url;
	});

export const uploadedFileUrl = file => fileUrl(file, true);
export const tempFileUrl = file => fileUrl(file, false);
export const permanentFileUrl = file => permanentFileUrl(file);

export const downloadByUrl = (fileName, url) => {
	var a = document.createElement('a');
	a.href = url;
	a.setAttribute('target', '_blank');
	a.setAttribute('download', fileName);
	a.click();
};

export const downloadFile = file => downloadByUrl(file.fileName, fileUrl(file, file.isUsed));

export const downloadUploadedFile = file => downloadByUrl(file.fileName, uploadedFileUrl(file));

export const downloadTempFile = file => downloadByUrl(file.fileName, tempFileUrl(file));

export const tabAriaProps = (idPrefix, index) => ({
	id: `${idPrefix}-${index}`,
	'aria-controls': `${idPrefix}-panel-${index}`,
	value: index
});

export const tabPanelAriaProps = (idPrefix, index) => ({
	id: `${idPrefix}-panel-${index}`,
	'aria-labelledby': `${idPrefix}-${index}`
});

export const getStaticDataUrl = (fileName, subSystem) => `/app/assets/static-data/${fileName}`;

export const FormManager = (form, setForm, validateInfos) => {
	const [errors, setErrors] = useState({});
	const handleChangeNumber = event =>
		handleChange({ target: { name: event.target.name, value: parseInt(event.target.value) } });

	const handleChange = event => {
		let key = event.target.name,
			value = event.target.value;
		delete errors[key];
		validateInfos(key).forEach(item => {
			if (!item.validate(value)) {
				errors[key] = item.message();
			}
		});
		form[key] = value;
		setErrors({ ...errors });
		setForm({ ...form });
	};

	const setFormErrors = () => {
		Object.keys(form).forEach(key => {
			delete errors[key];
			validateInfos(key) &&
				validateInfos(key).forEach(item => {
					if (!item.validate(form[key])) {
						errors[key] = item.message();
					}
				});
		});
		setErrors({ ...errors });
	};

	return { errors, setErrors, handleChange, handleChangeNumber, setFormErrors };
};

export const getTicketGategories = subSystem =>
	TicketCategories.filter(tc => tc.subSystem === subSystem).map(tc => ({
		category: tc.category,
		key: tc.key,
		order: tc.order,
		value: tc.value
	}));

export const getFaqCategories = subSystem =>
	FaqCategories.filter(tc => tc.subSystem === subSystem).map(tc => ({ category: tc.category, key: tc.key }));

export const getKeyByValue = (obj, value) => Object.keys(obj).find(key => obj[key] === value);

export const formatBytes = (bytes, decimals = 3) => {
	if (bytes === 0) return '0 Bytes';
	const k = 1024;
	const sizes = ['Bytes', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + sizes[i];
};

export const generateGuid = () => {
	return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
		(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
	);
};

export const svgToImage = (svg, fileName) => ({
	svg,
	id: (Math.random() * -1000).toFixed(),
	fileName,
	fileLabel: fileName,
	url: `data:image/svg+xml;base64,${btoa(svg)}`
})
